import { GelIcon } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import * as Styled from "./styles";
import Flexbox from "../../../common/components/FlexBox";
import { useContext } from "react";
import {
  GelScreenDetectorContext,
} from '@tal-gel/components';


const { global: { themeColorTextDefault, sizeBaseX4, sizeBaseX2 } } = getGelTokens();

interface Props extends React.ComponentProps<"a"> {
  paymentDate?: string;
  text?: string;
  amount?: string;
  onClick?: () => void;
  variant?: "clickable" | "not-clickable" | "hidden";
  isDisabled?: boolean;
}

export const PaymentItem = ({
  paymentDate: title = "&nbsp",
  text = "&nbsp",
  amount: date = "&nbsp",
  onClick = () => { },
  variant = "clickable",
  isDisabled = false,
  ...rest
}: Props) => {
  const { screen, isXsScreen } = useContext(GelScreenDetectorContext) as any; //GelScreenDetectorContext;
  const isInteractive = variant === "not-clickable" || variant === "hidden";

  return (
    <Styled.Link
      role="button"
      onClick={onClick}
      isInteractive={isInteractive}
      {...(isDisabled ? { tabIndex: -1, isDisabled } : { tabIndex: 0 })}
      {...rest}
      style={
        variant === "hidden"
          ? { visibility: "hidden", pointerEvents: "none" }
          : {}
      }
    >
      <Flexbox flexDirection="column" flexGrow={1} gap={16} >
        <div>
          <Styled.DateText as="p">{title}</Styled.DateText>
          <Styled.SubText as="p">{text}</Styled.SubText>
        </div>
        {isXsScreen(screen) ? <Styled.DateText as="p">{date}</Styled.DateText> : null}

      </Flexbox>
      <div style={{ display: 'flex', alignItems: 'center', marginRight: `${sizeBaseX4}px` }}>
        {!isXsScreen(screen) ? <Styled.DateText as="p">{date}</Styled.DateText> : null}
      </div>

      {variant === "clickable" ? (
      <Styled.IconWrapper style={{ margin: isXsScreen(screen) ? 'initial' : 'auto', paddingBottom: isXsScreen(screen) ? '0px' : '4px', marginRight: '0px' }}>
        <GelIcon
          name="ArrowRight"
          width="24"
          color={themeColorTextDefault}
        />
      </Styled.IconWrapper>
      ) : null}
    </Styled.Link>
  );
};